<template>
<div id="app" class="privacy-policy page-template-default page page-id-3 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="privacy" :gotodownload="gotodownload"
      :apk="apk"/>

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article id="post-3" class="post-3 page type-page status-publish">
            <div class="inside-article">
              <header class="entry-header section-content" aria-label="Content">
                <h1 class="entry-title" itemprop="headline">
                   Privacy Policy
                </h1>
                <!-- <span><strong>Effective Date: </strong>[03/12/2024]</span> -->

              </header>

              <div class="section-content" itemprop="text">
                <p>
                  At <a href="/" class="jump-url">sotifyapp.com</a>, your privacy is important to us. This Privacy Policy outlines the types of information we collect, how we use it, and the steps we take to protect your data.
                </p>
                <h2>Information We Collect</h2>
                <p>
                  We may collect the following data:
                  <ul>
                    <li> Non-personal information such as browser type, device, and operating system for analytics.</li>
                    <li> Cookies to enhance user experience and measure site performance.</li>
                    We do <strong>not collect:</strong>
                    <li> Personal information (e.g., names, emails, addresses) unless voluntarily provided via contact forms.</li>
                  </ul>
                </p>

                <h2>How We Use Information</h2>
                <ul>
                  <li> To improve website performance and user experience.</li>
                  <li> To monitor traffic and prevent fraud or abuse.</li>
                  <li> For responding to inquiries submitted via our contact page.</li>
                </ul>

                <h2>Cookies</h2>
                <p>
                We use cookies for:
                <ul>
                  <li> Google Analytics tracking.</li>
                  <li> Remembering user preferences.</li>
                  <li> Enhancing performance and usability.</li>
                </ul>
                You may disable cookies in your browser settings if preferred.
                </p>

                <h2>Third-Party Links</h2>
                <p>
                 We may link to third-party sites. We are not responsible for the privacy practices or content of those sites. Please read their privacy policies separately.
                </p>

                <h2>Data Security</h2>
                <p>
                  We use standard industry protocols to protect your data from unauthorized access or misuse.
                </p>
                <h2>Changes to This Policy</h2>
                <p>
                  We may update this Privacy Policy occasionally. Updates will be posted on this page with a revised date.
                </p>
                <h2>Contact Us</h2>
                <p> For questions about this policy, contact us .</p>
              </div>

              <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
            </div>
          </article>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Privacy',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'privacy',

      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  margin-top: 20px !important;
}

.section-content {
  margin-top: 0;
  margin-bottom: 15px;
}

#maincontent {
  margin-top: 22px !important;
}
</style>
